import { useEffect } from "react";
import { useCmsContent } from "./use-cms-content";

function hexToHSL(hex: string): string | null {
  if (!hex || !hex.startsWith("#")) return null;
  const r = parseInt(hex.slice(1, 3), 16) / 255;
  const g = parseInt(hex.slice(3, 5), 16) / 255;
  const b = parseInt(hex.slice(5, 7), 16) / 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  let h = 0, s = 0;
  const l = (max + min) / 2;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r: h = ((g - b) / d + (g < b ? 6 : 0)) / 6; break;
      case g: h = ((b - r) / d + 2) / 6; break;
      case b: h = ((r - g) / d + 4) / 6; break;
    }
  }
  return `${Math.round(h * 360)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
}

const colorMap: Record<string, string> = {
  color_primary: "--primary",
  color_background: "--background",
  color_foreground: "--foreground",
  color_accent: "--accent",
  color_secondary: "--secondary",
  color_card: "--card",
};

export const useDynamicTheme = () => {
  const { content, loading } = useCmsContent();

  useEffect(() => {
    if (loading) return;
    const root = document.documentElement;
    Object.entries(colorMap).forEach(([key, cssVar]) => {
      const hex = content[key];
      if (hex) {
        const hsl = hexToHSL(hex);
        if (hsl) root.style.setProperty(cssVar, hsl);
      }
    });

    return () => {
      Object.values(colorMap).forEach((cssVar) => {
        document.documentElement.style.removeProperty(cssVar);
      });
    };
  }, [content, loading]);
};
